<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="3" xl="3"></CCol>

      <!-- HEADER -->
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CCardHeader class="d-flex justify-content-between">
          <b>
            <span>
              <i class="fas fa-users"></i> Lista de clientes
            </span>
          </b>

          <button @click="$emit('back')" class="btn btn-sm text-white" style="background:#E46666">
            <i class="fas fa-hand-point-left"></i> Retroceder
          </button>
        </CCardHeader>
      </CCol>

      <!-- LISTA CLIENTES -->
      <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
        <div class="scroll-container">
          <h4 class="text-center"><b>LISTA DE CLIENTES</b></h4>
          <div v-for="(item, index) in clients" :key="index" class="card">
            <div class="card-body d-flex align-items-center p-3">

              <input type="checkbox" v-model="select" :value="item" class="mr-3" />

              <div>

                <div class="text-value">
                  {{ item.name_client }}
                </div>

                <div class="text-muted small">
                  {{ item.services }}
                </div>

                <div class="text-muted small">
                  Último contacto: {{ formatDate(item.ultimo_contacto) }}
                </div>
                <!-- <div class="text-muted small font-weight-bold">
                  {{ item.index }}
                </div> -->
                <div class="mt-1">
                  <CBadge :color="getStatusColor(item.status)">
                    {{ item.status }}
                  </CBadge>

                  <CBadge color="secondary" class="ml-1">
                    {{ item.index }}
                  </CBadge>
                </div>
              </div>

            </div>
          </div>

        </div>

      </CCol>

      <!-- CLIENTES SELECCIONADOS -->
      <CCol lg="4" class="mt-2">
        <div class="scroll-container">
          <h4 class="text-center"><b>CLIENTES SELECCIONADOS</b></h4>

          <template v-if="select.length > 0">
            <div v-for="(item, index) in select" :key="index" class="card">
              <div class="card-body">
                <div class="text-value">
                  {{ item.name_client }}
                </div>

                <div class="text-muted small">
                  {{ item.services }}
                </div>
              </div>
            </div>
          </template>

          <div v-else class="card-body text-center">
            <div class="text-white bg-gradient-info p-3">
              No tiene clientes seleccionados
            </div>
          </div>

        </div>

      </CCol>

      <!-- MENSAJE -->
      <CCol lg="4" class="mt-2">

        <h4 class="text-center"><b>MENSAJE PARA ENVIAR</b></h4>

        <textarea rows="10" class="form-control form-control-sm" v-model="message" :disabled="select.length === 0"
          placeholder="Escriba un mensaje para enviar..." />
        <span>** Para colocar el nombre del cliente en automatico presione aqui: <button class="btn btn-sm btn-info"
            @click="mtdAddNameClientWsp">Añadi nombre de cliente</button></span><br>
        <button class="btn btn-success w-100 mt-2" :disabled="select.length === 0" @click="sendMessage">
          <i class="far fa-paper-plane"></i> Enviar mensaje
        </button>

      </CCol>

    </CRow>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {

  props: {
    clients: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      select: [],
      message: "",
      castMessagge: [],
    }
  },

  methods: {
    ...mapActions(["post"]),
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY")
    },
    mtdAddNameClientWsp: function () {
      this.message += " nombre_cliente ";
    },
    getStatusColor(status) {
      switch (status) {

        case "BAJA":
          return "success"

        case "MEDIA":
          return "warning"

        case "ALTA":
          return "danger"

        default:
          return "secondary"
      }
    },
    sendMessage() {

      if (!this.message.includes("nombre_cliente")) {
        Swal.fire(
          "Atención",
          "Debe agregar el nombre del cliente antes de enviar el mensaje.",
          "warning"
        );
        return;
      }
      const messages = this.select.map(c => ({
        clientId: c.client_id,
        name: c.name_client,
        phone: c.phone,
        message: this.message.replace("nombre_cliente", c.name_client)
      }))

      this.post({
        url: this.$store.getters.get__url + "/crm/send",
        token: this.$store.getters.get__token,
        params: {
          wsp: messages
        }
      })
        .then((response) => {
          if (response.statusCode === 200) {
            this.select = []
            this.message = ""
            Swal.fire({
              title: "MENSAJES ENVIADOS!!",
              icon: "success",
            })
          }
        })
    }

  }

}
</script>

<style scoped>
.grid {
  display: grid;
  gap: 1rem;
}

.scroll-container {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  padding-right: 8px;

}
</style>